//1B30F5 0017E9 3DBDAE D8F4F1 69E8C9 FFB661 1C31F5 -> D9B55A
//EAF1F8 DBE7FC F0F5FA F7F9FC -> F2F2F2
//3E4685 3F4785 6A98F2 000000 -> #5C7987
//6284C6 5489ED DEE7EF 3E4688 -> 949494
//FC0167 FFDDE9 F67AA6 -> FF453A
//F2F7FB B7D0F0 -> FFFFFF
//C5A6F6 -> FF840A
//63C7F1 -> 30D148
//C1D3F8 -> 707070
//D2E0FA -> FFFFFF

const fid = {
  text: {
    documentSectionFieldTitle: '#6D76AA',
    primary: '#1A1C1D',
    white: '#FFFFFF',
    navBar: '#5C7987',
    darkBlue: '#1A1C1D',
    blue: '#5C7987',
    transparentGray: '#7D81A8',
    darkMain: '#505B67',
    lightGray: '#828282',
    secondGray: '#8E92CA',
    labelGray: '#A5ADCA',
    red: '#FF6258',
    secondaryRed: '#FF0068',
    conflictRed: '#FF453A',
    greenCheck: '#28B59B',
    green: '#29B137',
    greenSecond: '#28AD9F',
    greenSuccess: '#37B9A3',
    blueLabel: '#5C7987',
    hoverBlue: '#E4002B',
    black: '#5C7987',
    blueLabelDisabled: '#707070',
    gold: '#ffc107',
    info: '#5C7987',
    blueEmpty: '#5C7987',
  },
  bg: {
    documentSectionGray: '#F7FAFC',
    pink: '#DF9EB5',
    primary: '#F2F2F2',
    hover: '#77D6B0',
    navBar: '#FFFFFF',
    blue: '#5C7987',
    blueSecond: '#E4002B',
    blueEmpty: '#F2F2F2',
    toxicBlue: '#E4002B',
    green: '#28B59B',
    greenCheck: '#28B59B',
    gray: '#ECF0F5',
    secondGray: '#AEBACF',
    input: '#FFFFFF',
    red: '#FF0000',
    blueLabel: '#949494',
    conflictRed: '#FF453A',
    grayMedium: '#CCD2E3',
    greyLight: '#F1F6FB',
    dividerLine: '#F2F2F2',
    grayDisabled: '#DDE6F4',
    grayEdit: '#F2F2F2',
    grayBadge: '#F2F2F2',
    checkboxBg: '#FFFFFF',
    checkedBg: '#28B59B',
    grayBlur: '#FFFFFF',
    burgundyRed: '#DE035C',
    transparentBlueLabel: '#ffffff80',
    toastError: '#FF2D55',
    toastGreen: '#00C868',
    toastBlue: '#64D2FF',
    purple: '#9A7DED',
    black: '#5C7987',
    modalBg: '#0B0E2C',
    scrollBar: '#5C7987',
    whiteTransparent: 'rgba(255, 255, 255, 0.9)',
    white: '#FFFFFF',
    blueLabelDisabled: '#F4F9FD',
    transparentWhite: '#F2F2F2',
    noActiveWhite: '#FFFFFF',
    lightGray: '#707070',
    closedBg: '#ECECEE',
    canceledBg: '#F4E8EC',
    warningBg: '#E4002B',
    periwinkle: '#CEDCFF',
    darkPrimary: '#0300A9',
    teal: '#E4002B',
  },
  status: {
    green: '#000000',
    mintGreen: '#96DCBA',
    azure: '#30D148',
    blue: '#949494',
    purple: '#FF840A',
    pink: '#000000',
    orange: '#F49090',
    gray: '#97ACCA',
    lightGreen: '#E4002B',
    lightMintGreen: '#D5F6E6',
    lightAzure: '#E1F2F9',
    lightPurple: '#EBE2FA',
    lightPink: '#FF453A',
    lightOrange: '#F8E1E1',
    lightGray: '#DBE4F1',
    primaryBlue: '#E4002B',
    red: '#FF0068',
  },
  icon: {
    white: '#FFFFFF',
    navBar: '#5C7987',
    navBarLink: '#5C7987',
    primary: '#5C7987',
    arrowBlue: '#949494',
    secondBlue: '#5C7987',
    blueLabelDisabled: '#707070',
    blue: '#E4002B',
    purple: '#8E92CA',
    red: '#FF0068',
    conflictRed: '#FF453A',
    greenSecond: '#28AD9F',
    original: '#28AF9D',
    greenCheck: '#28B59B',
    gray: '#323232',
    green: '#4EC970',
    greenSuccess: '#37B9A3',
    grayOff: '#D9D9D9',
  },
  border: {
    documentSectionBorder: '#ECF3F9',
    conflictRed: '#FF453A',
    focus: '#E4002B',
    active: '#E4002B',
    valid: '#29B137',
    invalid: '#FF6258',
    white: '#ffffff',
    blue: '#5C7987',
    green: '#4EC970',
    secondBlue: '#E4002B',
    input: '#CCD2E3',
    darkGray: '#AAB4BD',
    dividerLine: '#F2F2F2',
    lightGray: '#707070',
    blueStroke: '#010168',
    blueLabel: '#949494',
    blueDash: '#D2E0FA',
    blueEmptyDash: '#949494',
    checkbox: '#949494',
    greenCheck: '#28B59B',
    crayola: '#BFCDE7',
    aliceBlue: '#FEF5EC',
    greyDividerLine: '#E4EDF6',
  },
  contentLoader: {
    base: '#E4002B',
    highlight: '#5C7987',
  },
  gradient: {
    tabButton: 'linear-gradient(180deg, #fff 0%, #FFFFFF00 50%)',
  },
  shadow: {
    primary: 'rgba(228, 0, 43, 0.1)',
  },
  btn: {
    primary: {
      bg: '#5C7987',
      bgHover: '#FFFFFF',
      text: '#FFFFFF',
      textDisabled: '#707070',
    },
    secondary: {
      bg: '#FFFFFF',
      bgDisabled: '#F4F9FD',
      text: '#5C7987',
      textDisabled: '#707070',
      border: '#F2F2F2',
      borderHover: '#5C7987',
    },
    success: {
      text: '#FFFFFF',
      bg: '#28B59B',
    },
    inCircle: {
      bg: '#FFFFFF',
      border: '#F2F2F2',
    },
    iconButton: {
      bg: 'transparent',
      border: 'none',
    },
    dashedBlue: {
      border: '#FFFFFF',
      bg: '#e4ecf6',
    },
    default: {
      bgDisabled: '#ECF0F5',
      textDisabled: '#FFFFFF',
      border: 'transparent',
    },
  },
  logo: {
    backgroundImage: 'fid-logo.svg',
  },
  logoName: {
    backgroundImage: 'fid-logo.svg',
  },
  primary: '#E4002B',
  secondary: '#5C7987',
}

export default fid
